import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/pages/Home'
import ProductList from '@/pages/Product/List'
import ProductCate from '@/pages/Product/Cate'
import Details from '@/pages/Product/Details'
import uadd from '@/pages/User/add'
import Login from '@/pages/Login/Login'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',name: 'Home',component: Home
    },
    {
      path: '/ProductList',name: 'ProductList',component: ProductList,
      children:[
        {
          path: '/ProductList',name: 'ProductList',component: ProductList
        },
        {
          path: '/ProductCate',name: 'ProductCate',component: ProductCate
        }
      ]
    },
    {
      path: '/Details',name: 'Details',component: Details
    }, 
    {
      path: '/uadd',name: 'uadd',component: uadd
    }, 
    {
      path: '/Login',name: 'Login',component: Login
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js